import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    step: 0,
    jobData: {},

};

const jobSlice = createSlice({
    name: 'job',
    initialState,
    reducers: {
        update: (state, action) => {
            for (let data in action.payload) {
                state.jobData[data] = action.payload[data]
            }
        },
        nextStep: (state) => {
            state.step += 1
        },
        customStep: (state, action) => {
            state.step = action.payload
        },
        previousStep: (state) => {
            state.step -= 1
        },
        emptyJob: (state) => {
            return initialState;
        },
        skipStep: (state, action) => {
            if (!state.skippedSteps.includes(action.payload)) {
                state.skippedSteps.push(action.payload);
            }
        },
        removeSkippedSteps: (state, action) => {
            const stepsToRemove = action.payload;
            if (stepsToRemove === 'all') {
                state.skippedSteps = [];
            } else {
                state.skippedSteps = state.skippedSteps.filter(step => !stepsToRemove.includes(step));
            }
        },
    },
});

export const { update, nextStep, previousStep, skipStep, removeSkippedSteps, emptyJob, customStep } = jobSlice.actions;
export default jobSlice.reducer